import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useStoreUnitActions } from 'src/redux/helpers';
import { RoutableTabsLayout } from 'src/router';
import companiesStore from '../redux';
import { routes } from './routes';

function CompanyDetails() {
  const { companyId } = useParams();
  const actions = useStoreUnitActions(companiesStore);

  useEffect(() => {
    actions.details(companyId);
  }, [companyId]);

  return <RoutableTabsLayout routes={routes} />;
}

export default CompanyDetails;
